export default __webpack_public_path__ + "static/media/Gruppe1.9851f0f4.webp";